import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import SearchUserMealsQuery from './SearchUserMealsQuery';

type UserMealSearchEdge = {
  cursor: string;
  node: UserMeal;
};

type UserMeal = {
  id: string;
  name: string;
  notes: string;
  calories: number;
  proteinGrams: number;
  carbsGrams: number;
  fatGrams: number;
};

type UserMealsSearchCriteriaInputType = {
  query: string;
};

interface IUserMealsSearchConnectorApollo {
  children: ({
    searchUserMeals,
    loading,
    meals,
    called,
  }: {
    searchUserMeals: (searchCriteria: UserMealsSearchCriteriaInputType) => Promise<any>;
    loading: boolean;
    meals: UserMealSearchEdge[];
    called: boolean;
  }) => React.ReactElement;
}

const UserMealsSearchConnectorApollo: React.FC<IUserMealsSearchConnectorApollo> = ({
  children,
}) => {
  const [searchUserMeals, { loading: apolloLoading, called }] = useLazyQuery(SearchUserMealsQuery);

  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState([]);

  const createSearchUserMeals = async (searchCriteria: UserMealsSearchCriteriaInputType) => {
    setIsSearching(true);

    try {
      const result = await searchUserMeals({ variables: { searchCriteria } });

      if (result.data?.dailyTracker.userMeals.edges) {
        setSearchResults(result.data.dailyTracker.userMeals.edges);
      }

      return result;
    } finally {
      setIsSearching(false);
    }
  };

  return children({
    searchUserMeals: createSearchUserMeals,
    loading: apolloLoading || isSearching,
    meals: searchResults,
    called: called || searchResults.length > 0,
  });
};

export default UserMealsSearchConnectorApollo;
